import React, { Component } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import classnames from 'classnames';

import { withTranslate, withTenant } from '../../core/TenantProvider';
import { Grid, CircularProgress, Link } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import APButton from '../../components/atoms/APButton';
import APImage from '../../components/atoms/APImage';
import APEmbed from '../../components/atoms/APEmbed';

import { ReducerState } from './../../redux/modules';
import { actions as ResourcesActions } from './../../redux/modules/resources';
import { actions as SlidingRightPanelActions } from './../../redux/modules/uistates';

import ResourcesContainerStyles from './styles/ResourcesContainer.style';
import FilterItem from './FilterItem';
import FiltersJSON from './reference/filters.json';

// icons
import { ReactComponent as CodeIcon } from "./assets/icons/icon-code.svg";
import { ReactComponent as ImageIcon } from "./assets/icons/icon-image.svg";
import { ReactComponent as Layoutx5Icon } from "./assets/icons/icon-layoutx5.svg";
import { ReactComponent as Layoutx3Icon } from "./assets/icons/icon-layoutx3.svg";
import { ReactComponent as EmptySVG } from "./assets/illustrations/empty.svg";
import { ReactComponent as AddIcon } from "./assets/icons/icon-add.svg";
import { ReactComponent as MinusIcon } from "./assets/icons/icon-minus.svg";
import fallbackImage from "../../components/atoms/APImage/assets/images/widget-preview-thumb.jpg";
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import { DEFAULT_LANGUAGE, REMOVE_CATEGORIES_FOR_TOR, TORFXOZ_REFERRING_VALUE, TORFX_REFERRING_VALUE } from '../../core/utils/Constants/Constants';
import GetBasicDetails from '../../core/utils/GetBasicDetails';
import { SelectedFilters } from '../../core/types/ResourcesTypes';

const resourceType = 'resource_type';
const industry = 'industry';
const clientType = 'client_type';
const country = 'country';
const trackingCode = 'trackingCode';

interface ResourcesContainerProps extends WithStyles<typeof ResourcesContainerStyles> {
    translate: Function,
    loadingState: string,
    getResources: Function,
    allResources: any,
    affiliateDetails: any,
    toggleSlidingRightPanelStatus: Function,
    results: any,
    settings: any
}

interface ResourcesContainerState {
    resourcesGrid: 'auto' | true | 3 | 4,
    resourcesPerPage: number,
    loadingMore: boolean,
    selectedFilters: SelectedFilters,
    hasSelectedFilters: boolean,
    currentPage: number,
    mobileFiltersOpen: boolean
}

export type ResourcesItem = {
    url_to_actual_image: string,
    image_title: string | null,
    image_dimensions: string,
    asset_id: string,
    file_type: string,
    category: string
}

type filterOption = {
    name: string,
    type: string,
    val: string
}

class ResourcesContainer extends Component<ResourcesContainerProps, ResourcesContainerState> {

    static layout3XPerPage = 9;
    static layout5XPerPage = 20;

    constructor(props: ResourcesContainerProps) {
        super(props);
        this.state = {
            resourcesGrid: 4,
            resourcesPerPage: ResourcesContainer.layout3XPerPage,
            loadingMore: false,
            mobileFiltersOpen: false,
            selectedFilters: {
                resource_type: [],
                industry: [],
                client_type: [],
                country: []
            },
            hasSelectedFilters: false,
            currentPage: 1
        };
    }

    handleClickLoadMore = (amount: any, e) => {
        e.preventDefault();
        this.setState(({
            loadingMore: true
        }));

        TriggerGoogleAnalyticsTag(
            GoogleAnalyticTags.eventAction.click,
            GoogleAnalyticTags.resources.click.loadMoreCTA
        );
        TriggerGoogleAnalytics4Tag(
            GoogleAnalytics4Tags.resources.name,
            GoogleAnalytics4Tags.eventAction.click,
            GoogleAnalytics4Tags.resources.click.loadMoreCTA
        );
        const addedAmount = (amount === 3) ? ResourcesContainer.layout5XPerPage : ResourcesContainer.layout3XPerPage;

        setTimeout(() => this.setState({
            loadingMore: false,
            resourcesPerPage: this.state.resourcesPerPage + addedAmount,
            currentPage: this.state.currentPage + 1
        }), 750
        );
    }

    handleClickLayout = (amount: any, e) => {
        e.preventDefault();
        this.setState(({
            resourcesGrid: amount,
            resourcesPerPage: (amount === 3) ? ResourcesContainer.layout5XPerPage : ResourcesContainer.layout3XPerPage
        }));
    };

    handlePanelLinkClick = (sliderType: string, componentData?: any) => {

        if (sliderType === trackingCode) {
            TriggerGoogleAnalyticsTag(
                GoogleAnalyticTags.eventAction.click,
                GoogleAnalyticTags.resources.click.affiliateTrackingCodeLink
            );
            TriggerGoogleAnalytics4Tag(
                GoogleAnalytics4Tags.resources.name,
                GoogleAnalytics4Tags.eventAction.click,
                GoogleAnalytics4Tags.resources.click.affiliateTrackingCodeLink
            );
        }
        componentData['orgUrl'] = this.props.settings.ORG_URL;
        componentData['orgCode'] = this.props.settings.ORG_CODE;
        componentData['portalUrl'] = this.props.settings.PORTAL_URL;
        this.props.toggleSlidingRightPanelStatus(true, sliderType, componentData);
    }

    handleFilterChange(setFilters: object, filterType: string) {
        const { getResources } = this.props;
        let set = this.state.selectedFilters[filterType].includes(setFilters) ?
            this.state.selectedFilters[filterType].filter((i) => i !== setFilters) : setFilters;

        this.setState({
            hasSelectedFilters: true,
            selectedFilters: {
                ...this.state.selectedFilters,
                [filterType]: set
            }
        }, () => {

            getResources(this.state.selectedFilters);
        });
        if (set !== "") {
            switch (filterType) {
                case resourceType:
                    TriggerGoogleAnalyticsTag(
                        GoogleAnalyticTags.eventAction.select,
                        GoogleAnalyticTags.resources.select.filter.categories,
                        { filterCategories: set }
                    );
                    TriggerGoogleAnalytics4Tag(
                        GoogleAnalytics4Tags.resources.name,
                        GoogleAnalytics4Tags.eventAction.select,
                        GoogleAnalytics4Tags.resources.select.filter.categories,
                        { filterCategories: set }
                    );
                    break;
                case industry:
                    TriggerGoogleAnalyticsTag(
                        GoogleAnalyticTags.eventAction.select,
                        GoogleAnalyticTags.resources.select.filter.industry,
                        { filterIndustry: set }
                    );
                    TriggerGoogleAnalytics4Tag(
                        GoogleAnalytics4Tags.resources.name,
                        GoogleAnalytics4Tags.eventAction.select,
                        GoogleAnalytics4Tags.resources.select.filter.industry,
                        { filterIndustry: set }
                    );
                    break;
                case clientType:
                    TriggerGoogleAnalyticsTag(
                        GoogleAnalyticTags.eventAction.select,
                        GoogleAnalyticTags.resources.select.filter.clientType,
                        { filterClientType: set }
                    );
                    TriggerGoogleAnalytics4Tag(
                        GoogleAnalytics4Tags.resources.name,
                        GoogleAnalytics4Tags.eventAction.select,
                        GoogleAnalytics4Tags.resources.select.filter.clientType,
                        { filterClientType: set }
                    );
                    break;
                case country:
                    TriggerGoogleAnalyticsTag(
                        GoogleAnalyticTags.eventAction.select,
                        GoogleAnalyticTags.resources.select.filter.countries,
                        { filterCountries: set }
                    );
                    TriggerGoogleAnalytics4Tag(
                        GoogleAnalytics4Tags.resources.name,
                        GoogleAnalytics4Tags.eventAction.select,
                        GoogleAnalytics4Tags.resources.select.filter.countries,
                        { filterCountries: set }
                    );
                    break;
            }
        }
    }

    componentDidMount(): void {
        const { getResources } = this.props;
        getResources(this.state.selectedFilters);
    }

    mobileFilterToggle() {

        this.setState(prevState => ({
            mobileFiltersOpen: !prevState.mobileFiltersOpen
        }));
    }

    render() {
        const { translate, classes, allResources, loadingState } = this.props;
        const { resourcesPerPage, resourcesGrid, loadingMore, mobileFiltersOpen } = this.state;

        let width = resourcesGrid;
        const totalPages = (allResources && allResources.length > 0) ? (Math.ceil(allResources.length / resourcesPerPage)) : 1;

        const layout3XActive = (resourcesGrid === 4 ? 'is-active' : '');
        const layout5XActive = (resourcesGrid === 3 ? 'is-active' : '');

        const totalPerPage = resourcesPerPage - 1;
        const { referringCompany } = GetBasicDetails();
        const isTorfx: boolean = (referringCompany === TORFX_REFERRING_VALUE || referringCompany === TORFXOZ_REFERRING_VALUE);

        const userSelectedLanguage: string | null = localStorage.getItem('preferredLanguage') ?? DEFAULT_LANGUAGE;
        const dropdownFiltersJSON = FiltersJSON[userSelectedLanguage];

        const showFilterItem: JSX.Element[] = dropdownFiltersJSON.filterLinks.map((value, index) => {
            const filterOptionsItems: filterOption[] = dropdownFiltersJSON.filterOptions
                .filter(filter => (filter.type === value.type) &&
                    (isTorfx ? !REMOVE_CATEGORIES_FOR_TOR.includes(filter.val) : true));

            return <FilterItem
                handleChange={this.handleFilterChange.bind(this)}
                key={`filterlinks_${index}`}
                label={value.label}
                filterOptions={filterOptionsItems}
                filterType={value.type} />;
        })

        return (
            <div className={classes.resourcesContainer}>
                <div className={classes.resourcesContainerInner}>
                    {/* Heading */}
                    <div className={classes.resourcesHeader}>
                        <h1>{translate('resources.details.heading')}</h1>
                        <p>{translate('resources.details.copy')}</p>
                        <button onClick={this.handlePanelLinkClick.bind(this, 'trackingCode')}><CodeIcon /> {translate('resources.details.heading.link')}</button>
                    </div>

                    {/* Filters */}
                    <button onClick={this.mobileFilterToggle.bind(this)} className={classnames(classes.filtersMobileToggle, (mobileFiltersOpen) ? classes.filtersMobileToggle : classes.filtersMobileToggleClosed)}>
                        {mobileFiltersOpen ? <MinusIcon /> : <AddIcon />} Filters
                    </button>

                    <div className={classnames(classes.filtersBar, (mobileFiltersOpen) ? classes.filtersBarMobileOpen : classes.filtersBarMobileClosed)}>
                        <nav>
                            <ul>
                                <li>{translate('resources.filters.label')}</li>
                                {showFilterItem}
                            </ul>
                        </nav>
                        <div className={classes.filtersBarIcons}>
                            <ul>
                                <li className={layout3XActive}><Link href="#" onClick={this.handleClickLayout.bind(this, 4)} color="inherit"><Layoutx3Icon /></Link></li>
                                <li className={layout5XActive}><Link href="#" onClick={this.handleClickLayout.bind(this, 3)} color="inherit"><Layoutx5Icon /></Link></li>
                            </ul>
                        </div>
                    </div>

                    {/* Cards */}
                    {loadingState === 'LOADING' || loadingState === 'UNINITIALISED' ? (
                        <div><CircularProgress className={classes.resourcesCardsItemSpinner} /></div>
                    ) :
                        <Grid className={classes.resourcesCardsWrapper} container spacing={3}>
                            {allResources && allResources.length > 0 ? (allResources.slice(0, resourcesPerPage).map((resource, index) => {
                                return (
                                    <Grid item xs={12} sm={6} md={width} key={index}>
                                        <div style={{ animationDelay: `${(index / totalPerPage).toFixed(2)}s` }} className={`${resource.file_type} ${classes.resourcesCardsItem}`} onClick={this.handlePanelLinkClick.bind(this, 'resourceItem', resource)}>
                                            <div className={`${resource.file_type} ${classes.resourcesCardsItemImg}`}>
                                                {getResourceType(resource, classes)}
                                                <div className={classes.resourcesCardsItemImgOverlay}>
                                                    <APButton className={classes.resourcesCardsItemBtn} onClick={this.handlePanelLinkClick.bind(this, 'resourceItem', resource)} variant="contained" color="primary">
                                                        {translate('resources.details.view')}
                                                    </APButton>
                                                </div>
                                                {getResourceTypeIcon(resource) &&
                                                    <span className={classes.resourcesCardsItemCorner}>
                                                        <span />
                                                        {getResourceTypeIcon(resource)}
                                                    </span>
                                                }
                                            </div>
                                            <div className={classes.resourcesCardsItemText}>
                                                {resource.image_title && (<span className={classes.resourcesCardsItemTextTitle}>{resource.image_title}</span>)}
                                                {resource.category && (<span className={classes.resourcesCardsItemTextSub}>{resource.category} {resource.image_dimensions ? resource.image_dimensions : ''}</span>)}
                                            </div>
                                        </div>
                                    </Grid>
                                );
                            })) : (
                                <div className={classes.emptyResults}>
                                    <EmptySVG />
                                    <h2>{translate('resources.details.heading.no')}</h2>
                                    <p>{translate('resources.details.paragraph.one.no')}</p>
                                </div>)}
                        </Grid>
                    }

                    {totalPages > 1 && loadingMore &&
                        <div><CircularProgress className={classes.loadMoreButtonSpinner} /></div>
                    }
                    {totalPages > 1 && !loadingMore &&
                        <APButton className={classes.loadMoreButton} onClick={this.handleClickLoadMore.bind(this, width)}>{translate('resources.details.load.more')}</APButton>
                    }

                </div>
            </div>
        );
    }
}

const getFileUrl = (url) => url.replace(/^((http[s]):\/)?\/?([^:\/\s]+)/, '');/* eslint-disable-line */
const getResourceType = (resource: ResourcesItem, classes: { resourcesCardsItemImgTag: string, resourcesCardsItemEmbedTag: string }) => {

    const fileUrl = `/Affiliate${getFileUrl(`${resource.url_to_actual_image}`)}`;
    switch (resource.file_type) {
        case 'GIF':
        case 'gif':
        case 'jpg':
        case 'png':
        case 'jpeg':
            return (<APImage imageSrc={fileUrl} imageClass={classes.resourcesCardsItemImgTag} />);

        case 'pdf':
            return (<APEmbed embedSrc={fileUrl} embedClass={classes.resourcesCardsItemEmbedTag} />);

        //case 'pdf':
        default:
            return <img className={classes.resourcesCardsItemImgTag} alt={''} src={fallbackImage} />
    }
};

const getResourceTypeIcon = (resource: ResourcesItem) => {

    switch (resource.file_type) {
        case 'html':
            return <CodeIcon />;

        case 'gif':
        case 'jpg':
        case 'png':
        case 'jpeg':
        case 'pdf':
            return <ImageIcon />;
        default:
    }
};

const mapStateToProps = (store: ReducerState) => ({
    allResources: store.resources.allResources,
    affiliateDetails: store.user.affiliateDetails,
    loadingState: store.resources.loadingState
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
    getResources: ResourcesActions.getResources,
    toggleSlidingRightPanelStatus: SlidingRightPanelActions.toggleSlidingRightPanelStatus
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
    withTenant(
        withTranslate(
            withStyles(ResourcesContainerStyles)(ResourcesContainer)
        )
    )
);
